import { range, find } from "lodash"
import { Button } from "evergreen-ui"

const neuronFeatureVis = (layer, neuron) => {
  return `https://storage.googleapis.com/fls/nickc/neuron_renders/${layer}_${neuron}.jpg`
}

const neuronImage = (model, layer, neuron) => {
  if (model === "inceptionv1") {
    return neuronFeatureVis(layer, neuron)
  }

  return `https://storage.googleapis.com/clarity-public/nick/feature_visualizations/${model}/${layer.replace(
    /\//g,
    "_",
  )}/${neuron}.jpg`
}

export default class Sequence extends Component {
  state = { modules: {}, activeModule: "" }

  componentWillMount() {
    const modules = localStorage.getItem("modules")
      ? JSON.parse(localStorage.getItem("modules"))
      : {}

    this.setState({ modules })
  }

  onSetNeuron = neuron => {
    const { modules, activeModule } = this.state

    const currentModule = this.getModule(neuron)

    if (currentModule) {
      delete modules[currentModule][neuron]
    } else {
      modules[activeModule][neuron] = true
    }

    this.onSetModules(modules)
  }

  getModule = neuron => {
    const { modules, activeModule } = this.state
    return find(Object.keys(modules), name => modules[name][neuron])
  }

  onSetModules = modules => {
    localStorage.setItem("modules", JSON.stringify(modules))
    this.setState({ modules })
  }

  onCreateModule = name => {
    const { modules } = this.state
    modules[name] = {}
    this.onSetModules(modules)
  }

  render() {
    const { modules, activeModule } = this.state
    return (
      <Surface width={"100%"} flexFlow="row" padding={100}>
        <Surface flexFlow="row" width={1600} flexWrap="wrap">
          {range(480).map(neuron => {
            const moduleName = this.getModule(neuron)

            return (
              <Surface marginY={8} marginX={3}>
                <img
                  onDoubleClick={() => this.onSetNeuron(neuron)}
                  src={neuronImage("inceptionv1", "mixed3b", neuron)}
                  opacity={moduleName && 0.7}
                />
                <Text>
                  {neuron}, {moduleName}
                </Text>
              </Surface>
            )
          })}
        </Surface>
        <Surface>
          <Surface flexFlow="row" flexWrap="wrap" width={1200}>
            {Object.keys(modules).map(name => (
              <Surface
                onClick={() => this.setState({ activeModule: name })}
                style={{
                  border: `${name === activeModule ? 3 : 1}px solid black`,
                }}
                padding={10}
                margin={10}
                borderRadius={5}
              >
                <Text size={600}>{name}</Text>
                <Surface flexFlow="row" width={500} flexWrap="wrap">
                  {Object.keys(modules[name]).map(neuron => (
                    <Surface>
                      <img
                        src={neuronImage("inceptionv1", "mixed3b", neuron)}
                      />
                      <Text>{neuron}</Text>
                    </Surface>
                  ))}
                </Surface>
              </Surface>
            ))}
          </Surface>
          <Button onClick={() => this.onCreateModule(prompt("name?"))}>
            create module
          </Button>
        </Surface>
      </Surface>
    )
  }
}
